import { toast } from "react-toastify";

import { errMsg } from "../../utils/helperFunction";
import {
  uploadAuditApi,
  getClientAuditStatusApi,
  getRawAuditSheetsApi,
} from "../../api/clientApi";

export const uploadAuditSheets =
  (
    uploadCurrentYear,
    clientId,
    unit,
    balanceSheet,
    profitLoss,
    rawBalanceSheet,
    rawProfitLoss
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "UPLOAD_AUD_SHEET_REQ",
      });

      const reqBody = {
        uploadCurrentYear,
        clientId,
        balanceSheet,
        profitLoss,
        rawBalanceSheet,
        rawProfitLoss,
        unit,
      };

      const data = await uploadAuditApi(clientId, reqBody);

      dispatch({
        type: "UPLOAD_AUD_SHEET_SUC",
        payload: { ...data },
      });

    } catch (err) {
      const { message } = errMsg(err);
      toast.error(message, {
        toastId: message,
        position: "bottom-center",
      });

      dispatch({
        type: "UPLOAD_AUD_SHEET_ERROR",
        payload: { success: false, message },
      });
    }
  };

export const getRawAuditSheets = (clientId,reqBody) => async (dispatch) => {
  try {
    dispatch({ type: "RAW_AUDIT_SHEET_REQ" });

    const data = await getRawAuditSheetsApi(clientId,reqBody);

    dispatch({
      type: "RAW_AUDIT_SHEET_SUC",
      payload: { ...data },
    });
  } catch (err) {
    console.error(err);
    const { message } = errMsg(err);

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });

    dispatch({
      type: "RAW_AUDIT_SHEET_ERROR",
      payload: { success: false, message },
    });
  }
};

export const getClientIdForAudtiSheet = (clientId) => {
  return (dispatch) => {
    dispatch({
      type: "GET_CLIENT_ID_FOR_AUDTI_SHEET",
      payload: { clientId },
    });
  };
};


export const getClientAuditStatus = (clientId) => async (dispatch) => {
  try {
    dispatch({ type: "UPLOAD_AUD_STATUS_REQ" });

    const data = await getClientAuditStatusApi(clientId);

    dispatch({
      type: "UPLOAD_AUD_STATUS_SUC",
      payload: { ...data },
    });
  } catch (err) {
    console.error(err);
    const { message } = errMsg(err);

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });

    dispatch({
      type: "UPLOAD_AUD_STATUS_ERROR",
      payload: { success: false, message },
    });
  }
};
